const funcion = $event => {
  if (!(/[a-z]/i.test($event.key) || $event.keyCode == 32 || $event.keyCode == 209 || $event.keyCode == 241))
    $event.preventDefault();
};

export default funcion;
